import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Switch from '@material-ui/core/Switch';
import Checkbox from '@material-ui/core/Checkbox';
import Tooltip from '@material-ui/core/Tooltip';
import { OutlinedInput } from "@material-ui/core";
import { Grid, Paper } from "@material-ui/core";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import * as XLSX from 'xlsx';
import { toast } from 'react-toastify';


const useStyles = makeStyles(() => ({
    wrapper2: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
    },
    wrapper3: {
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'center',
        gap: '16px',
    },
    scrollContainer: {
        maxHeight: 212,            // cap the height so content scrolls vertically
        overflowY: 'auto',
        overflowX: 'auto',         // allow horizontal scroll if columns overflow
        boxShadow: 'none',
        width: '100%',
        '&::-webkit-scrollbar': {
            display: 'none !important',
        },
        scrollbarWidth: 'none !important',
        msOverflowStyle: 'none !important',
        '& .MuiTableHead-root': {
            position: 'sticky',
            top: 0,
            zIndex: 10,
        },
        '& .MuiTableHead-root .MuiTableCell-root': {
            position: 'sticky',
            top: 0,
            zIndex: 10,
            backgroundColor: '#fff',
        },
    },
    tableContainer: {
        width: '100%',
        maxHeight: 'calc(100vh - 570px)',            // cap the height so content scrolls vertically
        overflowX: 'auto',
        overflowY: 'auto',
        boxShadow: 'none',
        '&::-webkit-scrollbar': {
            display: 'none !important',
        },
        '& .MuiTableHead-root': {
            position: 'sticky',
            top: 0,
            zIndex: 10,
        },
        '& .MuiTableHead-root .MuiTableCell-root': {
            position: 'sticky',
            top: 0,
            zIndex: 10,
            backgroundColor: '#fff',
        },
        '@media (max-width: 1280px)': {
            maxHeight: 'calc(100vh - 250px)',   //suggest 400 but laxmi asked more table more should visible initially // adjust as needed
        },

        '@media (max-width: 1024px)': {
            maxHeight: 'calc(100vh - 200px)',   //suggest 300 smaller screens / higher zoom
        },
    },
    actionIcon: {
        width: 25,
        height: 25,
        cursor: 'pointer',
    },
    actionIcon1: {
        width: 17,
        height: 24,
        cursor: 'pointer',
    },
}));

const useStylesww = makeStyles(() => ({
    smallPagination: {
        "& .MuiTablePagination-caption": {
            flexShrink: 0,
            fontSize: "12px",
        },
        "& .MuiTablePagination-selectRoot": {
            fontSize: "12px",
        },
        "& .MuiTablePagination-displayedRows": {
            fontSize: "12px",
        },
        "& .MuiTablePagination-actions .MuiIconButton-root": {
            padding: "4px",
        },
        "& .MuiTablePagination-actions svg": {
            fontSize: "16px",
        },
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    paper: {
        backgroundColor: '#fff',
        boxShadow: 'none',
    },
}));

export default function SimpleTableViewer(props) {

    const { pagination, formData, selectedDataElement, dataModel, selectedTableDataElement, dataObj, isActionEnabled, isObjectTable, isEditButton, isDeleteButton, isDownloadButton, onEdit, onDelete, onDownload, isViewButton, onView, blockState, enableWorkflow, totalRecords, isCheckbox, onCheckboxChange, selectedRows, sort, onSortChange, isGlobalDownloadEnable, isGobalDownloadEnable, onGlobalDownload, globalDownloadTitle, isLinkButton, onLink, rowIdKey, linkButtonTitle, isEnableSelectAll, isEnableMultipleSelection = true, isActionColumnSticky = false, isContractUnavailable } = props || {};


    const classes = useStyles();
    const classesww = useStylesww();

    const [page, setPage] = React.useState(props?.page || 0);
    const [rowsPerPage, setRowsPerPage] = React.useState(props?.rowsPerPage || 10);
    const [blockHeaders, setBlockHeaders] = useState([])
    const [localSelectedRows, setLocalSelectedRows] = useState(selectedRows || [])

    const isScrollable = !pagination;

    // Sync with external selectedRows if provided
    useEffect(() => {
        if (selectedRows !== undefined) {
            setLocalSelectedRows(selectedRows)
        }
    }, [selectedRows])

    // Sync page and rowsPerPage with props when they change
    useEffect(() => {
        if (props.page !== undefined && props.page !== page) {
            setPage(props.page);
        }
    }, [props.page]);

    useEffect(() => {
        if (props.rowsPerPage !== undefined && props.rowsPerPage !== rowsPerPage) {
            setRowsPerPage(props.rowsPerPage);
        }
    }, [props.rowsPerPage]);

    const handleCheckboxChange = (rowId, isChecked) => {
        let updatedSelection;
        if (isChecked) {
            updatedSelection = isEnableMultipleSelection
                ? [...new Set([...localSelectedRows, rowId])]
                : [rowId]
        } else {
            updatedSelection = localSelectedRows.filter(id => id !== rowId)
        }
        setLocalSelectedRows(updatedSelection)
        if (onCheckboxChange) {
            onCheckboxChange(updatedSelection, rowId, isChecked)
        }
    }

    const isRowSelected = (rowId) => {
        return localSelectedRows.includes(rowId)
    }

    const getRowId = (row, fallback) => (
        rowIdKey && row?.[rowIdKey] != null && row?.[rowIdKey] !== ''
            ? row[rowIdKey]
            : (row?.id || row?._id || fallback)
    )

    const visibleRowIds = Array.isArray(dataObj)
        ? dataObj.map((row, index) => getRowId(row, index))
        : []
    const areAllVisibleRowsSelected = visibleRowIds.length > 0
        && visibleRowIds.every(rowId => localSelectedRows.includes(rowId))
    const areSomeVisibleRowsSelected = visibleRowIds.some(rowId => localSelectedRows.includes(rowId))

    const handleSelectAllVisibleRows = (isChecked) => {
        const visibleIds = new Set(visibleRowIds)
        const updatedSelection = isChecked
            ? [...new Set([...localSelectedRows, ...visibleRowIds])]
            : localSelectedRows.filter(rowId => !visibleIds.has(rowId))
        setLocalSelectedRows(updatedSelection)
        if (onCheckboxChange) {
            onCheckboxChange(updatedSelection)
        }
    }


    console.log('SimpleTableViewer**props', props, dataObj, blockHeaders)

    const gnerateHeaderData = () => {
        console.log('gnerateHeaderData**formData', formData, dataModel, selectedDataElement)
        if (formData?.dataModel?.[dataModel] && dataModel && selectedDataElement?.length) {
            let dataElements = formData.dataModel[dataModel].dataElements || []
            if (dataElements?.length) {
                let fdes = []
                if (selectedDataElement) {
                    fdes = JSON.parse(JSON.stringify(selectedDataElement))
                    fdes = fdes.map(fde => {
                        let sde = dataElements.find(de => de.name === fde.value)
                        if (sde?.name) {
                            return { ...sde, ...fde }
                        } else {
                            return fde
                        }

                    })
                    setBlockHeaders(fdes)
                }
            }
        }
        else {
            console.log('gnerateHeaderData**else', formData, dataModel, selectedDataElement)
        }
    }

    useEffect(() => {
        console.log('gnerateHeaderData**useeffect', selectedDataElement)
        isObjectTable && gnerateHeaderData()
    }, [isObjectTable, formData, dataModel, selectedDataElement])

    const cellStyle = {
        padding: '8px',
        fontSize: '12px',
        fontWeight: '400',
        fontStyle: 'normal',
        lineHeight: '17px',
        color: 'rgba(95, 96, 113, 1)',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        minWidth: 80,
        maxWidth: 200,
        border: '1px solid rgba(233, 235, 245, 1)', // if you want grid
    };

    const cellStyle1 = {
        padding: '8px',
        fontSize: '12px',
        fontWeight: '500',
        fontStyle: 'normal',
        lineHeight: '17px',
        color: 'rgba(69, 70, 83, 1)',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        minWidth: 80,
        maxWidth: 200,
        border: '1px solid rgba(233, 235, 245, 1)', // if you want grid
    };

    const stickyActionHeaderStyle = isActionColumnSticky
        ? {
            position: 'sticky',
            right: 0,
            top: 0,
            zIndex: 13,
            width: 80,
            minWidth: 80,
            maxWidth: 80,
            textAlign: 'center',
            backgroundColor: '#fff',
            boxShadow: '-4px 0 8px rgba(0, 0, 0, 0.06)',
        }
        : {};

    const stickyActionCellStyle = isActionColumnSticky
        ? {
            position: 'sticky',
            right: 0,
            zIndex: 4,
            width: 80,
            minWidth: 80,
            maxWidth: 80,
            textAlign: 'center',
            backgroundColor: '#fff',
            boxShadow: '-4px 0 8px rgba(0, 0, 0, 0.06)',
        }
        : {};

    const handleChangePage = (event, newPage) => {
        props.onPageChange(event, newPage)
    };

    const handleChangeRowsPerPage = (event) => {
        // setRowsPerPage(parseInt(event.target.value, 10));
        // setPage(0);
        props.onRowsPerPageChange(event)
    };

    const handleSort = (columnValue) => {
        if (!onSortChange || !columnValue) return;

        const currentSort = sort || {};
        const currentDirection = currentSort[columnValue];

        let newSort = {};

        // Toggle sort: none -> asc -> desc -> none
        if (!currentDirection) {
            newSort = { [columnValue]: 1 };
        } else if (currentDirection === 1) {
            newSort = { [columnValue]: -1 };
        } else {
            newSort = {};
        }

        onSortChange(newSort);
    };

    const getSortDirection = (columnValue) => {
        if (!sort || !columnValue) return null;
        return sort[columnValue] || null;
    };

    const formatDate = (dateValue) => {
        if (!dateValue) return '-';
        try {
            const date = new Date(dateValue);
            if (isNaN(date.getTime())) return dateValue; // Invalid date, return original
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}/${month}/${year}`;
        } catch (error) {
            return dateValue;
        }
    };

    const formatAmount = (amountValue, isPound, isDoller, isPercentage) => {
        if (amountValue === null || amountValue === undefined || amountValue === '') return '-';
        try {
            const numValue = typeof amountValue === 'string' ? parseFloat(amountValue.replace(/,/g, '')) : parseFloat(amountValue);
            if (isNaN(numValue)) return amountValue;
            if (isPound) {
                return `£${numValue.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })}`;
            }
            else if (isDoller) {
                return `$${numValue.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })}`;
            }
            else if (isPercentage) {
                return `${numValue.toLocaleString('en-US', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })}%`;
            }
            return numValue.toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });

        } catch (error) {
            return amountValue;
        }
    };

    const formatCellValue = (cellValue, col) => {
        if (col?.isDate) {
            return formatDate(cellValue);
        } else if (col?.isAmount) {
            return formatAmount(cellValue, col?.isPound, col?.isDoller, col?.isPercentage);
        }
        return cellValue;
    };

    // Resolves the "Name" column for object tables: rows are keyed by data element
    // name, so the label comes from the data model description or the configured label.
    const getObjectRowName = (key, valuex, col) => {
        const description = blockHeaders?.find((bh) => bh.name === key || bh.value === key)?.description;
        if (description) return description;

        const label = selectedDataElement?.find((de) => de.value === key)?.label;
        if (label) return label;

        if (col?.value === 'field') return valuex?.[col?.value] || '-';

        return key || '-';
    };

    const getObjectTableRawCell = (key, valuex, col) => {
        let cellValue = '';
        if (col.label === 'Name') {
            cellValue = getObjectRowName(key, valuex, col);
        } else if (col.label === 'Sentence') {
            const cellVal = valuex?.[col?.value];
            cellValue = cellVal?.[0]?.value || '-';
        } else {
            const cellVal = valuex[col?.value];
            if (Array.isArray(cellVal)) {
                cellValue = cellVal[0]?.value || '-';
            } else if (typeof cellVal === 'object' && cellVal !== null) {
                cellValue = cellVal.value || cellVal.name || '-';
            } else {
                cellValue = cellVal || '-';
            }
        }
        return cellValue;
    };

    const hasObjectExportRows = isObjectTable && dataObj && typeof dataObj === 'object' && !Array.isArray(dataObj) && Object.keys(dataObj).length > 0;
    const hasArrayExportRows = !isObjectTable && dataObj && Array.isArray(dataObj) && dataObj.length > 0;
    console.log('hasObjectExportRows', hasObjectExportRows, hasArrayExportRows, dataObj)
    const hasExportableData = hasObjectExportRows || hasArrayExportRows;

    const globalDownloadOn =
        Boolean(isGlobalDownloadEnable || isGobalDownloadEnable) &&
        hasExportableData

    const downloadTooltipTitle = globalDownloadTitle || 'Download';

    const handleGlobalDownloadExcel = () => {
        const cols = selectedTableDataElement;
        if (!Array.isArray(cols) || cols.length === 0) {
            toast.warn('Table columns are not configured.');
            return;
        }
        const columnDefs = cols.filter((c) => c && c.value != null && c.value !== '');
        if (columnDefs.length === 0) {
            toast.warn('Table columns are not configured.');
            return;
        }
        const headerRow = columnDefs.map((c) => (c.label != null && c.label !== '' ? c.label : c.value));
        let dataRows = [];
        if (isObjectTable && dataObj && typeof dataObj === 'object' && !Array.isArray(dataObj)) {
            dataRows = Object.entries(dataObj).map(([rowKey, valuex]) =>
                columnDefs.map((col) => String(formatCellValue(getObjectTableRawCell(rowKey, valuex, col), col) ?? '')),
            );
        } else if (Array.isArray(dataObj)) {
            dataRows = dataObj.map((valuex) =>
                columnDefs.map((col) => {
                    const cellValue = valuex[col?.value] || '-';
                    return String(formatCellValue(cellValue, col) ?? '');
                }),
            );
        }
        if (dataRows.length === 0) {
            toast.info('No data to download.');
            return;
        }
        const sheet = XLSX.utils.aoa_to_sheet([headerRow, ...dataRows]);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, sheet, 'Data');
        const rawTitle = props.title || props.name || 'table_export';
        const safeName = String(rawTitle).replace(/[^\w\-]+/g, '_').slice(0, 80) || 'table_export';
        XLSX.writeFile(wb, `${safeName}.xlsx`);
    };

    const handleDownloadClick = () => {
        // if (typeof onGlobalDownload === 'function') {
        //     onGlobalDownload();
        //     return;
        // }
        handleGlobalDownloadExcel();
    };

    return (
        <React.Fragment>
            <div className={classes.wrapper2}>
                {
                    props.title && (
                        <div style={{ height: '40px', boxSizing: 'border-box', display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                            <div style={{ height: '24px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', boxSizing: 'border-box' }}>
                                <div style={{ height: '20px', width: '2px', backgroundColor: '#3F51B5' }}>

                                </div>
                                <Typography style={{ fontSize: '14px', fontWeight: '400', color: '#5F6071', fontStyle: 'normal', lineHeight: '24px' }}>{`${props.title} : `}</Typography>
                            </div>
                            {globalDownloadOn ? (
                                <Tooltip title={downloadTooltipTitle}>
                                    <IconButton
                                        size="small"
                                        aria-label={downloadTooltipTitle}
                                        onClick={handleDownloadClick}
                                        style={{ padding: 4 }}
                                    >
                                        <img
                                            src="/media/createStepper/downloadIconNew.svg"
                                            alt=""
                                            style={{ width: 18, height: 18, display: 'block' }}
                                        />
                                    </IconButton>
                                </Tooltip>
                            ) : null}
                        </div>
                    )
                }
                <TableContainer
                    component={Paper}
                    className={`${isScrollable ? classes.scrollContainer : classes.tableContainer} myScrollContainer`}
                    style={{
                        boxShadow: 'none',
                    }}
                >
                    <Table
                        style={{
                            minWidth: '100%',
                            tableLayout: 'auto',
                            borderCollapse: 'collapse'
                        }}
                        aria-label="simple table"
                        stickyHeader={true}
                    >
                        <TableHead style={{ backgroundColor: '#fff', height: '40px', position: 'sticky', top: 0, zIndex: 10 }}>
                            <TableRow>
                                {isCheckbox && (
                                    <TableCell
                                        style={{
                                            ...cellStyle1,
                                            width: 50,
                                            textAlign: 'center',
                                            borderTopLeftRadius: '8px',
                                            position: 'sticky',
                                            top: 0,
                                            zIndex: 11,
                                            backgroundColor: '#fff',
                                        }}
                                    >
                                        {isEnableSelectAll && isEnableMultipleSelection && (
                                            <Checkbox
                                                checked={areAllVisibleRowsSelected}
                                                indeterminate={!areAllVisibleRowsSelected && areSomeVisibleRowsSelected}
                                                onChange={(event) => handleSelectAllVisibleRows(event.target.checked)}
                                                color="primary"
                                                size="small"
                                            />
                                        )}
                                    </TableCell>
                                )}
                                {selectedTableDataElement?.map((col, index) => {
                                    const isFirstColumn = index === 0 && !isCheckbox
                                    const isLastColumn = index === selectedTableDataElement.length - 1 && !isActionEnabled
                                    const cellContent = col?.label || col.label
                                    const columnValue = col?.value || col.value
                                    const sortDirection = getSortDirection(columnValue)
                                    const isSortable = onSortChange && columnValue

                                    return (
                                        <Tooltip key={index} title={cellContent || ''} arrow placement="top">
                                            <TableCell
                                                onClick={() => isSortable && handleSort(columnValue)}
                                                style={{
                                                    ...cellStyle1,
                                                    borderTopLeftRadius: isFirstColumn ? '8px' : 0,
                                                    borderTopRightRadius: isLastColumn ? '8px' : 0,
                                                    cursor: isSortable ? 'pointer' : 'default',
                                                    position: 'sticky',
                                                    top: 0,
                                                    zIndex: 11,
                                                    backgroundColor: '#fff',
                                                }}
                                            >
                                                <span style={{ marginRight: '4px' }}>{cellContent}</span>
                                                {isSortable && (
                                                    <span style={{ display: 'inline-flex', flexDirection: 'column', verticalAlign: 'middle', marginLeft: '2px', lineHeight: '1' }}>
                                                        <ArrowUpwardIcon
                                                            style={{
                                                                fontSize: '10px',
                                                                height: '8px',
                                                                color: sortDirection === 1 ? '#3F51B5' : 'rgba(120, 121, 142, 0.5)',
                                                                marginBottom: '-2px'
                                                            }}
                                                        />
                                                        <ArrowDownwardIcon
                                                            style={{
                                                                fontSize: '10px',
                                                                height: '8px',
                                                                color: sortDirection === -1 ? '#3F51B5' : 'rgba(120, 121, 142, 0.5)',
                                                                marginTop: '-2px'
                                                            }}
                                                        />
                                                    </span>
                                                )}
                                            </TableCell>
                                        </Tooltip>
                                    )
                                })}
                                {isActionEnabled && (
                                    <TableCell
                                        style={{
                                            ...cellStyle1,
                                            ...(isActionEnabled ? { width: 80, textAlign: 'center' } : {}),
                                            borderTopRightRadius: '8px',
                                            position: 'sticky',
                                            top: 0,
                                            zIndex: 11,
                                            backgroundColor: '#fff',
                                            ...stickyActionHeaderStyle,
                                        }}
                                    >
                                        Action
                                    </TableCell>
                                )}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {dataObj && typeof dataObj === 'object' && isObjectTable && Object.entries(dataObj).map(([key, valuex], idx) => {
                                const rowId = (rowIdKey && valuex?.[rowIdKey] != null && valuex?.[rowIdKey] !== '')
                                    ? valuex[rowIdKey]
                                    : (valuex?.id || valuex?._id || key || idx)
                                return (
                                    <TableRow key={idx}>
                                        {isCheckbox && (
                                            <TableCell style={{ ...cellStyle, width: 50, textAlign: 'center' }}>
                                                <Checkbox
                                                    checked={isRowSelected(rowId)}
                                                    onChange={(e) => handleCheckboxChange(rowId, e.target.checked)}
                                                    color="primary"
                                                    size="small"
                                                />
                                            </TableCell>
                                        )}
                                        {selectedTableDataElement?.map((col, index) => {
                                            let cellValue = '';
                                            if (col.label === 'Name') {
                                                cellValue = getObjectRowName(key, valuex, col)
                                            } else if (col.label === 'Sentence') {
                                                const cellVal = valuex?.[col?.value];
                                                cellValue = cellVal?.[0]?.value || '-'
                                            }
                                            else {
                                                const cellVal = valuex[col?.value];
                                                if (Array.isArray(cellVal)) {
                                                    cellValue = cellVal[0]?.value || '-';
                                                } else if (typeof cellVal === 'object' && cellVal !== null) {
                                                    cellValue = cellVal.value || cellVal.name || '-';
                                                } else {
                                                    cellValue = cellVal || '-';
                                                }
                                            }
                                            const formattedValue = formatCellValue(cellValue, col);
                                            const displayValue = String(formattedValue ?? '-')
                                            return (
                                                <Tooltip key={index} title={displayValue} arrow placement="top">
                                                    <TableCell style={cellStyle}>
                                                        <div style={{
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            width: '100%'
                                                        }}>
                                                            {displayValue}
                                                        </div>
                                                    </TableCell>
                                                </Tooltip>
                                            )
                                        })}
                                        {isActionEnabled && (
                                            <TableCell style={{ ...cellStyle, ...stickyActionCellStyle }}>
                                                <div style={{ display: 'flex', gap: 10 }}>
                                                    <img
                                                        src={'/media/createStepper/editButtonNewIcon.svg'}
                                                        alt="edit"
                                                        className={classes.actionIcon1}
                                                        title="Edit"
                                                    />
                                                    <img
                                                        src={'/media/createStepper/deleteContracts.svg'}
                                                        alt="delete"
                                                        className={classes.actionIcon}
                                                        title="Delete"
                                                    />
                                                    <img
                                                        src={'/media/createStepper/downloadIconNew.svg'}
                                                        alt="download"
                                                        className={classes.actionIcon1}
                                                        title="Download"
                                                    />
                                                </div>
                                            </TableCell>
                                        )}
                                    </TableRow>
                                )
                            })}
                            {dataObj && Array.isArray(dataObj) && !isObjectTable && dataObj?.length > 0 && dataObj?.map((valuex, idx) => {
                                const rowId = (rowIdKey && valuex?.[rowIdKey] != null && valuex?.[rowIdKey] !== '')
                                    ? valuex[rowIdKey]
                                    : (valuex?.id || valuex?._id || idx)
                                return (
                                    <TableRow key={idx}>
                                        {isCheckbox && (
                                            <TableCell style={{ ...cellStyle, width: 50, textAlign: 'center' }}>
                                                <Checkbox
                                                    checked={isRowSelected(rowId)}
                                                    onChange={(e) => handleCheckboxChange(rowId, e.target.checked)}
                                                    color="primary"
                                                    size="small"
                                                />
                                            </TableCell>
                                        )}
                                        {selectedTableDataElement?.map((col, index) => {
                                            const cellValue = valuex[col?.value] || '-'
                                            const formattedValue = formatCellValue(cellValue, col);
                                            const displayValue = String(formattedValue ?? '-')
                                            return (
                                                <Tooltip key={index} title={displayValue} arrow placement="top">
                                                    <TableCell style={cellStyle}>
                                                        <div style={{
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                            width: '100%'
                                                        }}>
                                                            {displayValue}
                                                        </div>
                                                    </TableCell>
                                                </Tooltip>
                                            )
                                        })}
                                        {isActionEnabled && (
                                            <TableCell style={{ ...cellStyle, ...stickyActionCellStyle }}>
                                                <div style={{ display: 'flex', gap: 10, ...(isActionEnabled ? { justifyContent: 'center' } : {}) }}>
                                                    {
                                                        isViewButton && (
                                                            <img
                                                                src={'/media/createStepper/viewIconNew.svg'}
                                                                alt="view"
                                                                className={classes.actionIcon1}
                                                                title="View"
                                                                onClick={() => onView(valuex, idx)}
                                                            />
                                                        )
                                                    }
                                                    {/* {
                                                        isEditButton && (props.enableWorkflow && blockState?.['status'] !== 'Rejected' && blockState?.['status'] !== 'Completed' && blockState?.workflow && blockState?.workflow?.currentRespondent?.id === props.members?._id) && (
                                                            <img
                                                                src={'/media/createStepper/editButtonNewIcon.svg'}
                                                                alt="edit"
                                                                className={classes.actionIcon1}
                                                                title="Edit"
                                                                onClick={() => onEdit(valuex, idx)}
                                                            />
                                                        )
                                                    }
                                                    {
                                                        isDeleteButton && (props.enableWorkflow && blockState?.['status'] !== 'Rejected' && blockState?.['status'] !== 'Completed' && blockState?.workflow && blockState?.workflow?.currentRespondent?.id === props.members?._id) && (
                                                            <img
                                                                src={'/media/createStepper/deleteContracts.svg'}
                                                                alt="delete"
                                                                className={classes.actionIcon}
                                                                title="Delete"
                                                                onClick={(e) => {
                                                                    if (props.name === 'supplementalInformation') {
                                                                        onDelete(valuex, idx)
                                                                    } else if (props.name === 'attachments') {
                                                                        onDelete(e, valuex)
                                                                    } else {
                                                                        onDelete(e, idx, valuex)
                                                                    }
                                                                }}
                                                            />
                                                        )
                                                    } */}
                                                    {
                                                        isEditButton &&
                                                        (
                                                            !props.enableWorkflow ||
                                                            (
                                                                blockState?.status !== 'Rejected' &&
                                                                blockState?.status !== 'Completed' &&
                                                                blockState?.workflow &&
                                                                blockState?.workflow?.currentRespondent?.id === props.members?._id
                                                            )
                                                        ) && (
                                                            <img
                                                                src={'/media/createStepper/editButtonNewIcon.svg'}
                                                                alt="edit"
                                                                className={classes.actionIcon1}
                                                                title="Edit"
                                                                onClick={() => onEdit(valuex, idx)}
                                                            />
                                                        )
                                                    }

                                                    {
                                                        isDeleteButton &&
                                                        (
                                                            !props.enableWorkflow ||
                                                            (
                                                                blockState?.status !== 'Rejected' &&
                                                                blockState?.status !== 'Completed' &&
                                                                blockState?.workflow &&
                                                                blockState?.workflow?.currentRespondent?.id === props.members?._id
                                                            )
                                                        ) && (
                                                            <img
                                                                src={'/media/createStepper/deleteContracts.svg'}
                                                                alt="delete"
                                                                className={classes.actionIcon}
                                                                title="Delete"
                                                                onClick={(e) => {
                                                                    if (props.name === 'supplementalInformation') {
                                                                        onDelete(valuex, idx);
                                                                    } else if (props.name === 'attachments') {
                                                                        onDelete(e, valuex);
                                                                    } else {
                                                                        onDelete(e, idx, valuex);
                                                                    }
                                                                }}
                                                            />
                                                        )
                                                    }

                                                    {
                                                        isDownloadButton && (
                                                            <img
                                                                src={'/media/createStepper/downloadIconNew.svg'}
                                                                alt="download"
                                                                className={classes.actionIcon1}
                                                                title="Download"
                                                                onClick={(e) => onDownload(e, valuex)}
                                                            />
                                                        )
                                                    }


                                                    {
                                                        isLinkButton && (
                                                            <img
                                                                src={'/media/createStepper/deleteContracts.svg'}
                                                                alt={linkButtonTitle || 'Unlink'}
                                                                className={classes.actionIcon}
                                                                title={linkButtonTitle || 'Unlink'}
                                                                onClick={(e) => onLink && onLink(e, valuex)}
                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                        )
                                                    }


                                                </div>
                                            </TableCell>
                                        )}
                                    </TableRow>
                                )
                            })}
                            {dataObj && Array.isArray(dataObj) && !isObjectTable && dataObj?.length === 0 && (
                                <TableRow>
                                    <TableCell colSpan={selectedTableDataElement?.length + (isCheckbox ? 1 : 0) + (isActionEnabled ? 1 : 0)} style={{ ...cellStyle, ...{ textAlign: 'center' } }}>
                                        No data found
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            {
                pagination && (<div className={classes.wrapper3}>
                    <TablePagination
                        component="div"
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        count={totalRecords}
                        className={classesww.smallPagination}
                        page={page}
                        onPageChange={handleChangePage}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </div>)
            }
        </React.Fragment>
    )
}
